import React, { useState, useRef, memo, useCallback } from "react";
import "./Map.scss";
import Icon from "@mdi/react";
import { mdiCloudUploadOutline } from "@mdi/js";
import overViewClock from "../../assets/Home/overViewClock.png";
import ScrollContainer from "react-indiana-drag-scroll";
import MapData from "./MapData";
import { useDispatch } from "react-redux";
import { closeDrawer } from "../../store";
import { Search } from "@mui/icons-material";

const StackUI = (props) => {
  const {
    polygon,
    deletMessage,
    handleAccept,
    buttonReset,
    showProduct,
    handleProductStack,
    stackProduct,
    setUploadedFile,
    handleOpenModal,
    handleStack,
    isStackItem,
    Stack,
    setdisplayMarker,
    displayMarker,
  } = props;
  const dispatch = useDispatch();
  const inputShapeFileRef = useRef(null);
  const inputKmlFileRef = useRef(null);
  const displayButton = [
    { label: "ایستگاه هیدرومتریک", value: "hydrometricSelect" },
    { label: "ایستگاه سینوپتیک", value: "synopticSelect" },
    { label: "ایستگاه هواشناسی", value: "weatherSelect" },
    { label: "سد ها", value: "damsSelect" },
  ];
  const [filterDiaplayButton, setFilterDiaplayButton] = useState(displayButton);
  const [filterMapData, setFilterMapData] = useState(MapData);

  const products = [
    { id: 1, title: " نقشه بسیمتری", time: false, tag: "BAS" },
    { id: 2, title: "تبخیر و تعرق", time: true, tag: "ET" },
    { id: 3, title: "ارتفاع", time: false, tag: "dem" },
    { id: 4, title: " کاربری اراضی WAPOR", time: false, tag: "cfw" },
    {
      id: 5,
      title: "کاربری اراضی FAO برای محصولات بهاره",
      time: false,
      tag: "cfs",
    },
    {
      id: 6,
      title: "کاربری اراضی FAO برای محصولات پاییزه",
      time: false,
      tag: "cff",
    },
  ];
  const handleSearchBar = useCallback(
    (e, displayButton) => {
      if (e.target.value) {
        const tmp = [...filterMapData];
        var pattern = `(?=.*${e.target.value})`;
        var regex = new RegExp(`${pattern}`, "g");
        // const searchPattern = new RegExp(`(?=.*${e.target.value})`);
        const filterData = tmp.filter((ele) => {
          return ele.name.toString().match(regex);
        });
        const filterData2 = displayButton.filter((ele) => {
          return ele.label.toString().match(regex);
        });
        setFilterMapData(filterData);
        setFilterDiaplayButton(filterData2);
      } else {
        setFilterMapData(MapData);
        setFilterDiaplayButton(displayButton);
      }
    },
    [filterMapData]
  );
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileObj = {
        type: event.target.name,
        data: file,
      };
      setUploadedFile(fileObj);
      console.log(fileObj);
    }
  };

  const handleTDProduct = (event, e) => {
    event.stopPropagation();
    dispatch(closeDrawer());
    handleOpenModal();
  };

  return (
    <div className="side-bar-container">
      <div style={{ height: "40%", padding: "10px 0" }}>
        <div className="upload-container">
          <button
            className="upload-button"
            onClick={() =>
              polygon ? deletMessage() : inputShapeFileRef.current.click()
            }
          >
            <p>Shape فایل</p>
            <Icon
              path={mdiCloudUploadOutline}
              title="User Profile"
              size={0.8}
              rotate={0}
              color="#00a18e"
            />
            <input
              ref={inputShapeFileRef}
              type="file"
              name="shp"
              hidden
              onChange={handleFileChange}
              onClick={() => (inputShapeFileRef.current.value = null)}
            />
          </button>
          <button
            className="upload-button"
            onClick={() =>
              polygon ? deletMessage() : inputKmlFileRef.current.click()
            }
          >
            <p>Kml فایل</p>
            <Icon
              path={mdiCloudUploadOutline}
              title="User Profile"
              size={0.8}
              rotate={0}
              color="#00a18e"
            />
            <input
              ref={inputKmlFileRef}
              type="file"
              name="kml"
              hidden
              onChange={handleFileChange}
              onClick={() => (inputKmlFileRef.current.value = null)}
            />
          </button>
          <h4>منطقه</h4>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px 0",
          }}
        >
          <button
            name="upload"
            className="accept-earth-button"
            onClick={handleAccept}
          >
            {buttonReset ? <p>ثبت مجدد</p> : <p>ثبت</p>}
          </button>
        </div>
        <ScrollContainer hideScrollbars={false} className="product-list">
          {products.map((e, index) => {
            return (
              <div
                className="container"
                key={e.id.toString()}
                onClick={() => {
                  showProduct && handleProductStack(e);
                }}
              >
                <div className="title-box" style={{ width: "75%" }}>
                  {e.title}
                </div>
                <div
                  style={{
                    width: "25%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {showProduct && (
                    <input
                      checked={stackProduct.findIndex((id) => id === e.id) > -1}
                      readOnly
                      type="checkbox"
                    />
                  )}
                  {e.time && (
                    <img
                      src={overViewClock}
                      alt="clock"
                      width="20"
                      onClick={(event) =>
                        showProduct && handleTDProduct(event, e)
                      }
                    />
                  )}
                </div>
              </div>
            );
          })}
        </ScrollContainer>
      </div>
      <div className="search-input">
        <div className="input-box">
          <input
            placeholder="جستجو"
            onChange={(e) => handleSearchBar(e, displayButton)}
            type="text"
          />
          <Search
            style={{
              position: "absolute",
              top: "calc(50% - 10px)",
              left: 8,
              width: 20,
              height: 20,
              color: "rgba(0,0,0,0.5)",
            }}
          />
        </div>
      </div>
      <ScrollContainer hideScrollbars={false} className="fileList">
        {filterMapData.map((e, index) => {
          return (
            <div
              key={(index ** 4).toString()}
              className="item-box"
              onClick={() => handleStack(index)}
            >
              <div>{e.name}</div>
              <input
                checked={isStackItem(Stack, index) > -1}
                readOnly
                type="checkbox"
              />
            </div>
          );
        })}
        {filterDiaplayButton.map((item, index) => (
          <div
            key={(index ** 2).toString()}
            onClick={() => {
              setdisplayMarker((prev) => ({
                ...displayMarker,
                [item.value]: !prev[item.value],
              }));
            }}
          >
            <div>{item.label}</div>
            <input
              checked={displayMarker[item.value]}
              onRateChange={() =>
                setdisplayMarker((prev) => ({
                  ...displayMarker,
                  [item.value]: !prev[item.value],
                }))
              }
              readOnly
              type="checkbox"
            />
          </div>
        ))}
      </ScrollContainer>
    </div>
  );
};

export default memo(StackUI);
